import { JSX } from 'react';

import Constants from '@helpers/Constants';
import * as Sentry from '@sentry/react-native';

// TODO: we have multiple versions of promise
export function initSentry() {
  Sentry.init({
    dsn: Constants.joinstar.sentry.dsn,
    debug: Constants.joinstar.DEV,
  });
}

export function wrapSentry(app: () => JSX.Element) {
  return Sentry.wrap(app);
}

export function captureException(
  error: Error,
  captureContext?: Parameters<typeof Sentry.captureException>[1]
) {
  return Sentry.captureException(error, captureContext);
}

export function captureMessage(message: string) {
  return Sentry.captureMessage(message);
}
